
import React from 'react';
import { Check, X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { AccountTypeBadge } from '@/components/common/AccountTypeBadge';
import { useTranslation } from 'react-i18next';

interface AccountStatusProps {
  isConnected: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const AccountStatus = ({ isConnected, size = 'md' }: AccountStatusProps) => {
  const { t } = useTranslation();
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-xs px-3 py-1.5',
    lg: 'text-sm px-4 py-2'
  };
  
  return (
    <Badge 
      variant={isConnected ? "default" : "outline"} 
      className={`font-semibold shadow-sm transition-all duration-200 ${sizeClasses[size]} ${
        isConnected 
          ? 'bg-green-500/20 text-green-700 hover:bg-green-500/30 border-green-500/30' 
          : 'bg-orange-500/20 text-orange-700 hover:bg-orange-500/30 border-orange-500/30'
      }`}
    >
      {isConnected ? (
        <div className="flex items-center gap-1.5">
          <div className="relative">
            <div className="h-2 w-2 bg-green-500 rounded-full"></div>
            <div className="absolute inset-0 h-2 w-2 bg-green-500 rounded-full animate-ping opacity-75"></div>
          </div>
          <span>{t('connected')}</span>
        </div>
      ) : (
        <div className="flex items-center gap-1.5">
          <div className="h-2 w-2 bg-orange-500 rounded-full"></div>
          <span>{t('disconnected')}</span>
        </div>
      )}
    </Badge>
  );
};

// Export the standardized badge component
export { AccountTypeBadge };
